import React from "react";
import ReactDOM from "react-dom";
import { App } from "./App.jsx";

// const root=ReactDOM.createRoot(document)

ReactDOM.render(<App />, document.getElementById("root"));
